import { Examples } from '@/types';

export const ExamplesIndexRoutes =
  process.env.NODE_ENV !== 'production'
    ? [
      {
        ...Examples.ExamplesIndex,
        components: {
          default: () => import(/* webpackChunkName: "ExampleMStoreAccordion" */
            '@/views/examples/ExamplesIndex.vue')
        }
      }
    ]
    : [];
